// extracted by mini-css-extract-plugin
module.exports = {"root":"TextArea_root__1zOb1","label":"TextArea_label__RWbz2","textarea":"TextArea_textarea__lats8","error":"TextArea_error__1NfuB","disabled":"TextArea_disabled__cSmAw"};